import React from 'react';
import Alert from 'react-bootstrap/Alert';

/**
 * @param {string} message
 * @param {string} type
 */
const CreateErrorAlert = ({message, type = "danger"}) => {
    return (
        <div className="row">
            <div className="col-12">
                <Alert variant={type +" text-center"}>
                    {message}
                </Alert>
            </div>
        </div>
    );
};

export default CreateErrorAlert;